var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Grid } from '@mui/material';
import Input from './Input';

var InputProxy = function InputProxy(_ref) {
  var _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === undefined ? 220 : _ref$minWidth,
      _ref$properties = _ref.properties,
      properties = _ref$properties === undefined ? {} : _ref$properties,
      _ref$labels = _ref.labels,
      labels = _ref$labels === undefined ? {} : _ref$labels,
      pkey = _ref.pkey,
      mkey = _ref.mkey,
      _ref$xs = _ref.xs,
      xs = _ref$xs === undefined ? 12 : _ref$xs,
      _ref$sm = _ref.sm,
      sm = _ref$sm === undefined ? 12 : _ref$sm,
      _ref$lg = _ref.lg,
      lg = _ref$lg === undefined ? 12 : _ref$lg,
      _ref$InputProps = _ref.InputProps,
      InputProps = _ref$InputProps === undefined ? {} : _ref$InputProps;

  if (R.isNil(pkey)) return null;
  if (!R.has(pkey, properties)) return null;

  var prop = R.propOr({}, pkey, properties);

  return React.createElement(
    Grid,
    { item: true, xs: xs, sm: sm, lg: lg, style: { minWidth: minWidth } },
    React.createElement(Input, _extends({}, prop, {
      value: R.when(R.isNil, R.always(''))(prop.value),
      type: 'number',
      label: R.prop(mkey || pkey, labels),
      fullWidth: true,
      InputProps: R.mergeRight({ endAdornment: null }, InputProps)
    }))
  );
};

InputProxy.propTypes = process.env.NODE_ENV !== "production" ? {
  minWidth: PropTypes.number,
  properties: PropTypes.object,
  labels: PropTypes.object,
  pkey: PropTypes.string,
  mkey: PropTypes.string,
  xs: PropTypes.number,
  sm: PropTypes.number,
  lg: PropTypes.number,
  InputProps: PropTypes.object
} : {};

export default InputProxy;